export const CATEGORY_RECEIPT_VISIT_RECORD = 1;
export const CATEGORY_RECEIPT_VISIT_RECORD_STAFF = 2;
export const CATEGORY_AGREEMENT_STORAGE = 3;
export const CATEGORY_INSURANCE_DIV = 4;
export const CATEGORY_ADD_DIV = 5;
export const CATEGORY_QUESTION = 6;
